import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function TestimonialsSection() {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'أحمد السعيد',
      position: 'المدير التنفيذي',
      company: 'شركة النجاح للتطوير',
      image: 'https://public.readdy.ai/ai/img_res/224cb1e4a3a0e6feb263fcae7075bbaf.jpg',
      rating: 5,
      text: 'تجربة استثنائية مع فريق محترف للغاية. ساعدونا في تطوير استراتيجيتنا المؤسسية وحققنا نتائج فاقت التوقعات. أنصح بشدة بالتعامل معهم.'
    },
    {
      id: 2,
      name: 'فاطمة المطيري',
      position: 'مديرة الموارد البشرية',
      company: 'مجموعة الرواد',
      image: 'https://readdy.ai/api/search-image?query=professional%20saudi%20arabian%20business%20woman%20wearing%20hijab%20in%20corporate%20attire%20smiling%20warmly%20with%20simple%20clean%20background&width=200&height=200&seq=testimonial-002&orientation=squarish',
      rating: 5,
      text: 'الاحترافية والجودة العالية في تقديم الخدمات. البرامج التدريبية التي قدموها لفريقنا كانت ممتازة وأحدثت فرقاً كبيراً في الأداء.'
    },
    {
      id: 3,
      name: 'خالد العتيبي',
      position: 'رئيس مجلس الإدارة',
      company: 'مؤسسة التميز',
      image: 'https://readdy.ai/api/search-image?query=distinguished%20saudi%20arabian%20senior%20business%20executive%20man%20in%20traditional%20attire%20looking%20professional%20with%20simple%20clean%20background&width=200&height=200&seq=testimonial-003&orientation=squarish',
      rating: 5,
      text: 'شريك موثوق في النجاح. خبرتهم العميقة وفهمهم لاحتياجاتنا جعل التعاون معهم مثمراً جداً. نتطلع للمزيد من المشاريع المشتركة.'
    },
    {
      id: 4,
      name: 'نورة الدوسري',
      position: 'مديرة التطوير',
      company: 'شركة الابتكار',
      image: 'https://readdy.ai/api/search-image?query=professional%20saudi%20arabian%20business%20woman%20executive%20wearing%20hijab%20smiling%20confidently%20with%20simple%20clean%20background&width=200&height=200&seq=testimonial-004&orientation=squarish',
      rating: 5,
      text: 'دقة في المواعيد والتزام تام بالجودة. الدراسات التي أعدوها لنا كانت شاملة ومفصلة وساعدتنا في اتخاذ قرارات استراتيجية صائبة.'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            آراء العملاء
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {t('testimonialsTitle')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('testimonialsSubtitle')}
          </p>
        </div>

        {/* Testimonials Slider */}
        <div className="max-w-5xl mx-auto relative">
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
            <div className="flex flex-col md:flex-row items-center gap-8">
              {/* Image */}
              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-blue-100">
                    <img 
                      src={testimonials[activeIndex].image}
                      alt={testimonials[activeIndex].name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-double-quotes-r text-2xl text-white"></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center md:text-right">
                {/* Rating */}
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>

                {/* Text */}
                <p className="text-lg text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonials[activeIndex].text}"
                </p>

                {/* Author */}
                <div>
                  <h4 className="text-xl font-bold text-gray-800">
                    {testimonials[activeIndex].name}
                  </h4>
                  <p className="text-blue-600 font-medium">
                    {testimonials[activeIndex].position}
                  </p>
                  <p className="text-gray-500 text-sm">
                    {testimonials[activeIndex].company}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button 
              onClick={prevTestimonial}
              className="w-12 h-12 bg-white hover:bg-blue-600 text-gray-800 hover:text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            
            {/* Dots */}
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === activeIndex ? 'bg-blue-600 w-8' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            <button 
              onClick={nextTestimonial}
              className="w-12 h-12 bg-white hover:bg-blue-600 text-gray-800 hover:text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}